
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9VQUw", function(module, exports) {

$parcel$export(module.exports, "VIEW_PAGE_FEATURES", () => $4ea72974304e25a5$export$1acbaeb6a9a6bc40);
$parcel$export(module.exports, "EDIT_PAGE_FEATURES", () => $4ea72974304e25a5$export$2c7469b01e61fde2);
$parcel$export(module.exports, "WHITEBOARD_FEATURES", () => $4ea72974304e25a5$export$72afc086e90eb0bf);

var $hpNab = parcelRequire("hpNab");
const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;

});

parcelRegister("acygG", function(module, exports) {

$parcel$export(module.exports, "useAllowedFeatures", () => $4d8c3108f114b71e$export$745a9b66a8f1814a);

var $gwFzn = parcelRequire("gwFzn");

var $iV5Ic = parcelRequire("iV5Ic");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");
const $4d8c3108f114b71e$var$QUERY_NAME = 'initialAllowedFeatures';
var $4d8c3108f114b71e$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $4d8c3108f114b71e$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $gwFzn.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $4d8c3108f114b71e$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $gwFzn.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    return !allowedFeatures && initialAllowedFeatures ? initialAllowedFeatures : allowedFeatures;
}

});

parcelRegister("96Bd7", function(module, exports) {

$parcel$export(module.exports, "usePageTheme", () => $d9c15609d405719e$export$6f1420f5b5e93922);

var $gwFzn = parcelRequire("gwFzn");

var $iV5Ic = parcelRequire("iV5Ic");

var $7zgzO = parcelRequire("7zgzO");

var $c3Qwv = parcelRequire("c3Qwv");

var $iZdrT = parcelRequire("iZdrT");
var $83wRA = parcelRequire("83wRA");
const $d9c15609d405719e$var$THEME_STATE_QUERY_PARAM = 'themeState';
const $d9c15609d405719e$export$6f1420f5b5e93922 = ()=>{
    // Below are the EP theming props
    const { themeState: themeStateProp } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const themeStateQueryParam = (0, $gwFzn.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $d9c15609d405719e$var$THEME_STATE_QUERY_PARAM), [
        getQueryParams
    ]);
    const finalTheme = (0, $gwFzn.useMemo)(()=>themeStateProp || (0, $83wRA.getThemeFromQueryParams)({
            themeState: themeStateQueryParam
        }), [
        themeStateProp,
        themeStateQueryParam
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // If a theme is requested and the global theme hasn't been set, set the global theme
        if (finalTheme) (0, $iZdrT.applyTheme)(finalTheme);
    }, [
        finalTheme
    ]);
    return finalTheme;
};

});
parcelRegister("83wRA", function(module, exports) {

$parcel$export(module.exports, "getThemeFromQueryParams", () => $2644e734697600df$export$a512a3cc8fd81b18);

var $j6S25 = parcelRequire("j6S25");
const $2644e734697600df$export$a512a3cc8fd81b18 = ({ themeState: themeState })=>themeState ? (0, $j6S25.themeStringToObject)(decodeURIComponent(themeState)) : null;

});



//# sourceMappingURL=EmbeddedViewPage.56a3afab.js.map
